const MEDIA_STATE_ACTIONS = {
    TOGGLE_PLAY: 'togglePlay',
    PLAY_NEXT: 'playNext',
    PLAY_PREV: 'playPrev',
    CHANGE_VOLUME: 'changeVolume',
    SET_MEDIA_STATE: 'setMediaState',
    SET_TRACK: 'setTrack'
}

export default MEDIA_STATE_ACTIONS